export default __webpack_public_path__ + "static/media/chevron_right_color.dd67ecd6.svg";